import UpdateForm, { UpdateFormOptions } from './UpdateForm';

export type { UpdateFormOptions };
export default UpdateForm;
